<form class="py-4 px-2 px-md-4 position-relative" [formGroup]="GPSForm" (submit)="onSubmit()">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <h4 class="text-bold pl-0 my-3">
        Crear tipo de GPS
    </h4>
    <div class="d-flex flex-wrap container-form">
        <mat-form-field appearance="outline" class="mb-4 col-md-6">
            <mat-label>Nombre<span class="asterisk">*</span></mat-label>
            <input matInput type="text" formControlName="name">
            <mat-error *ngIf="GPSForm.get('name').errors?.required">
                {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
            <mat-error *ngIf="GPSForm.get('name').errors?.gpsExists">
                El nombre ya está asociado a "{{GPSForm.get('name').errors?.gpsExists}}"
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="mb-4 col-md-6">
            <mat-label>URL<span class="asterisk">*</span></mat-label>
            <input matInput type="text" formControlName="id">
            <mat-error *ngIf="GPSForm.get('id').errors?.required">
                {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
            <mat-error *ngIf="GPSForm.get('id').errors?.gpsExists">
                La url ya está asociada a "{{GPSForm.get('id').errors?.gpsExists}}"
            </mat-error>
        </mat-form-field>
    </div>
    <div class="w-100 button-container">
        <button mat-raised-button class="primary-secondary button-width-auto" color="primary"
            (click)="dialogRef.close()" type="button">
            Cancelar
        </button>
        <button mat-raised-button color="primary" type="submit" class="button-width-auto bg-color-primary">
            Guardar
        </button>
    </div>
</form>